import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import PassiveOssicle from '@/assets/img/flash/blue_bone_cert.png';
import ActiveOssicle from '@/assets/img/flash/red_bone_cert.png';
import Prutik from '@/assets/img/flash/steel_stick.png';

const styles = () => ({
  passive: {
    backgroundImage: `url(${PassiveOssicle})`,
    backgroundRepeat: ' no-repeat',
    backgroundColor: 'transparent',
    backgroundSize: '40px 18px',
    backgroundPosition: 'center center',
    height: 18,
    width: 40,
  },
  white: {
    height: 18,
    width: 40,
    background: 'transparent',
  },
  active: {
    backgroundImage: `url(${ActiveOssicle})`,
    backgroundRepeat: ' no-repeat',
    backgroundColor: 'transparent',
    backgroundSize: '40px 18px',
    backgroundPosition: 'center center',
    height: 18,
    width: 40,
  },
  container: {
    backgroundImage: `url(${Prutik})`,
    backgroundRepeat: ' no-repeat',
    backgroundSize: '25px 100%',
    backgroundPositionX: 'center',
  },
});
/* eslint-disable no-nested-ternary, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
/**
 * Компонент отрисовки косточки
 * @param {object} props props.
 */
class Ossicle extends React.Component {
  /**
   * Class constructor.
   * @param {object} props props.
   */
  constructor(props) {
    super(props);

    this.handleClickBead = this.handleClickBead.bind(this);
  }

  /**
   * Обрабатывает клика на косточку
   */
  handleClickBead() {
    const { onClickBead } = this.props;
    onClickBead();
  }

  /**
   * Render
   * @returns {object}.
   */
  render() {
    const { classes, five, active, colors, passive, hidden } = this.props;
    const [activeClass, passiveClass, middleClass] = colors;

    const style = {
      margin: 'auto',
      textAlign: 'center',
      cursor: 'pointer',
    };
    return (
      <div className={classes.container}>
        {hidden ? (
          <div>
            <div className={classes.white} style={style} />
          </div>
        ) : five ? (
          <div
            className={active ? classes[activeClass] : classes[passiveClass]}
            style={style}
            onClick={this.handleClickBead}
          />
        ) : (
          <div
            className={
              active
                ? classes[middleClass]
                : passive
                ? classes[activeClass]
                : classes[passiveClass]
            }
            style={style}
            onClick={this.handleClickBead}
          />
        )}
      </div>
    );
  }
}

Ossicle.defaultProps = {
  passive: false,
  hidden: false,
};

Ossicle.propTypes = {
  classes: PropTypes.object.isRequired,
  onClickBead: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
  hidden: PropTypes.bool,
  passive: PropTypes.bool,
  five: PropTypes.bool.isRequired,
  colors: PropTypes.array.isRequired,
};

export default withStyles(styles)(Ossicle);

/* eslint-enable no-nested-ternary, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
